
import React, { Component } from 'react';

export default class VideoView extends Component {
    render () {
        const videoWrapper = {
            height: 300
        };
        const videoWrapperIframe = {
            position: 'relative',
            width: '100%',
            height: '80%'
        };
        let youtubeLinkCorrect = this.props.youtubeLink.replace('.com/watch?v=', '.com/embed/');
        youtubeLinkCorrect = youtubeLinkCorrect.replace('&t=', '?start=');
        return (
            <div style={videoWrapper}><iframe style={videoWrapperIframe} src={youtubeLinkCorrect} frameBorder='0' allowFullScreen /></div>
        );
    }
};



// WEBPACK FOOTER //
// ./src/views/components/videoView.js